<template>
  <div >
    <a id="TOPUp" href="#loud/monthQd" v-show="TOPUp">
      <el-button icon="el-icon-top" circle></el-button>
    </a>
    <breadcrumb :routerList="[{to:'/guanhuai',title:'信息漏斗'},{title:'月度抢单'}]"/>
    <!-- 弹窗-新建月度抢单 -->
    <div id="loud/monthQd" ref="faultTree" class="wrap"></div>
    <el-form :model="add" :inline="true" :rules="editFormRules" label-width="120" class="demo-ruleForm">
      <table style ="border-collapse: collapse;width:100%;border-color: #EAEEF5; margin-bottom: 10px" cellspacing =0 border="1">
        <tr style="background-color: #FAFAFA; text-align: center; color:#8F9399;height:40px;">
          <td style="width: 200px">月度</td>
          <td style="width: 200px">销售人员</td>
          <td style="width: 200px">区域</td>
          <td>渠道</td>
          <td>目标金额(万元)</td>
          <td>抢单总金额(万元)</td>
          <td>未来可抢金额(万元)</td>
          <td>实际金额(万元)</td>
        </tr>
        <tr v-for="item in add.bscUserMonthlyTargetChannel" >
          <td v-show="item.idx==0?true:false" :rowspan="item.idx==0?add.bscUserMonthlyTargetChannel.length:1">
            <el-date-picker type="month" placeholder="月度" v-model="add.month" value-format="yyyy-MM" style="width: 98%;padding: 5px 5px 5px 5px">
            </el-date-picker>
          </td>
          <td v-show="item.idx==0?true:false" :rowspan="item.idx==0?add.bscUserMonthlyTargetChannel.length:1">
            <el-select filterable v-model="add.userName" clearable placeholder="请选择" @change='getValue' style="width: 98%;padding: 5px 5px 5px 5px">
              <el-option
                  v-for="item in users"
                  :key="item.userCode"
                  :label="item.userName"
                  :value="item.userCode">
              </el-option>
            </el-select>
          </td>
          <td v-show="item.idx==0?true:false" :rowspan="item.idx==0?add.bscUserMonthlyTargetChannel.length:1">
            <brselect category="show_area" v-model="add.area" :v="add.area" :clearable="true" @change='getValue' style="width:98%;padding: 5px 5px 5px 5px"/>
          </td>
          <td style="text-align: center;padding: 5px 5px 5px 5px">{{item.channel}}</td>
          <td style="text-align: right;padding: 5px 5px 5px 5px">{{parseFloat(item.target==null?0:item.target).toFixed(2)}}</td>
          <td style="text-align: right;padding: 5px 5px 5px 5px">{{(parseFloat(item.grabOrder==null?0:item.grabOrder)+parseFloat(item.actual)).toFixed(2)}}</td>
          <td style="text-align: right;padding: 5px 5px 5px 5px">{{parseFloat(item.grabOrder==null?0:item.grabOrder).toFixed(2)}}</td>
          <td style="text-align: right;padding: 5px 5px 5px 5px">{{parseFloat(item.actual==null?0:item.actual).toFixed(2)}}</td>
        </tr>
        <tr style="background-color: #fafafa;text-align:right;">
          <td style="padding: 5px 5px 5px 5px">合计</td>
          <td></td>
          <td></td>
          <td></td>
          <td style="padding: 5px 5px 5px 5px">{{ this.sumFieldByData(add.bscUserMonthlyTargetChannel,'target').toFixed(2) }}</td>
          <td style="padding: 5px 5px 5px 5px">{{ ((this.sumFieldByData(add.bscUserMonthlyTargetChannel,'grabOrder')+this.sumFieldByData(add.bscUserMonthlyTargetChannel,'actual')).toFixed(2)) }}</td>
          <td style="padding: 5px 5px 5px 5px">{{ this.sumFieldByData(add.bscUserMonthlyTargetChannel,'grabOrder').toFixed(2) }}</td>
          <td style="padding: 5px 5px 5px 5px">{{ this.sumFieldByData(add.bscUserMonthlyTargetChannel,'actual').toFixed(2) }}</td>
        </tr>
      </table>
      <div style="position :absolute;z-index: 1 ;width: 100%; text-align: right ;padding-right: 68px;padding-top: 1px ">
        <el-button type="primary" icon="el-icon-edit-outline" size="medium" plain @click="dialogFormVisible = true">差因/关差原因</el-button>
      </div>

      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="月度汇总" name="first">
          <!--            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"-->
          <el-table
              row-key="loudProductId"
              :data="add.bscUserMonthlySummary"
              border
              show-summary
              :summary-method="getSummaries"
          >
            <el-table-column
                prop="month"
                label="月度"
                sortable
                width="90" >
            </el-table-column>
            <el-table-column
                align="right"
                prop="agentName"
                label="经销商"
                width="220"
                sortable
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="customerChannel"
                label="渠道"
                width="80"
                sortable>
              <template slot-scope="scope">
                <dictname category="sales_region" :v="scope.row.customerChannel"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="lianqun"
                label="链群"
                width="80"
                sortable>
              <template slot-scope="scope">
                <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="contractTarget"
                label="签约目标(万元)"
                sortable>
              <template slot-scope="scope" >
                <div  style=" text-align: right">{{ scope.row.contractTarget.toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="loudSum"
                label="漏斗金额(万元)"
                sortable>
              <template slot-scope="scope" >
                <div  style=" text-align: right">{{ scope.row.loudSum.toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="notLoudSum"
                label="非漏斗金额(万元)"
                sortable>
              <template slot-scope="scope">
                <div style=" text-align: right">{{ scope.row.notLoudSum.toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="grabOrder"
                label="抢单金额(万元)"
                sortable>
              <template slot-scope="scope">
                <div style=" text-align: right">{{ scope.row.grabOrder.toFixed(2) }}</div>
              </template>
            </el-table-column>
          </el-table>
          <span name="span" style="font-size:15px;position :absolute; padding-left: 15px;padding-top: 25px">漏斗明细</span>
          <p class="p" style=" text-align: right">
            <el-button-group>
              <el-button type="primary" icon="el-icon-search" size="medium" @click="showLd">选择漏斗</el-button>
              <el-button type="warning" icon="el-icon-delete" size="medium" @click="deleteSeleteMx">删除</el-button>
            </el-button-group>
          </p>
          <el-table
              ref="multipleTableLd"
              :data="add.bscUserMonthlyLoudDetails"
              border
              default-expand-all
              style="width: 100%; margin-top: 8px"
              @selection-change="handleSelectionChangeMx">
            <el-table-column
                type="selection"
                width="55" fixed>
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态1"
                width="70">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">正常</span>
                <span v-if="scope.row.status == 1">审批中</span>
                <span v-if="scope.row.status == 2">驳回</span>
                <span v-if="scope.row.status == 3">暂存</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="funnelCode"
                sortable
                label="漏斗编号"
                width="120">
            </el-table-column>
            <el-table-column
                prop="cuname"
                label="销售人员"
                width="77">
            </el-table-column>
            <el-table-column
                prop="agentName"
                label="经销商"
                sortable
                width="120" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="partner"
                label="合伙人"
                width="120">
            </el-table-column>
            <el-table-column
                prop="statusR"
                label="节点"
                width="100">
              <template slot-scope="scope">
                <dictname category="xinxi_jiedian" :v="scope.row.statusR"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="expOnlineDate"
                label="预计下单日期"
                width="110">
            </el-table-column>
            <el-table-column
                prop="expConvDate"
                label="预计转化日期"
                width="110">
            </el-table-column>
            <el-table-column
                prop="customerName"
                label="用户单位"
                width="120" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="customerChannel"
                label="渠道"
                width="70">
              <template slot-scope="scope">
                <dictname category="sales_region" :v="scope.row.customerChannel"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="lianqun"
                label="链群"
                width="70">
              <template slot-scope="scope">
                <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="proLevelOne"
                label="产品大类"
                width="120">
            </el-table-column>
            <el-table-column
                prop="proModel"
                label="型号"
                width="120">
            </el-table-column>
            <el-table-column
                prop="num"
                label="数量"
                width="120">
              <template slot-scope="scope">
                <div style=" text-align: right">{{ parseFloat(scope.row.num) || 0  }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="price"
                label="价格(万元)"
                width="120">
              <template slot-scope="scope">
                <div style=" text-align: right">{{ (parseFloat(scope.row.price) || 0).toFixed(2)  }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="totalPrice"
                label="金额(万元)"
                width="120">
              <template slot-scope="scope">
                <div style=" text-align: right">{{ (parseFloat(scope.row.totalPrice) || 0).toFixed(2)  }}</div>
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="120">
              <template slot-scope="scope">
                <el-button
                    @click.native.prevent="deleteRowMx(scope.$index,add.bscUserMonthlyLoudDetails)"
                    type="text"
                    size="small"
                    class="h-tableLink h-btn">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <span name="span" style="font-size:15px;position :absolute; padding-left: 15px;padding-top: 25px">非漏斗明细</span>
          <p class="p" style=" text-align: right">
            <el-button-group>
              <el-button type="primary" icon="el-icon-refresh" size="medium" @click="updateDataYd">更新月度汇总</el-button>
            </el-button-group>
          </p>
          <div id="app">
            <el-alert title="单位：万元" type="warning" style="margin-top: -5px;margin-bottom: 5px"></el-alert>
            <!--              <span style="position: absolute;margin-top:-7px;font-size:10px;color:#ff0000">单位：万元</span>-->
            <!--              <el-form ref="baseForm" :model="baseForm" :rules="rules">-->
            <el-table ref="table-input" highlight-current-row :data="add.bscUserMonthlyNotLoudDetails"
                      :header-cell-style='headerStyle'
                      border
                      default-expand-all
                      style="width: 100%; "
                      @row-click="selectItem">
              <el-table-column prop="" label="操作" width="115" fixed>
                <template>
                  <el-button-group>
                    <el-button type="primary"  size="mini" @click="addLine()" title="新增">＋
                    </el-button>
                    <el-button type="primary"  size="mini" title="删除">－</el-button>
                  </el-button-group>
                </template>
              </el-table-column>
              <el-table-column label="经销商" width="155">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.agentCode'" :rules="rules.agentName" class="all">
                    <el-select ref="ragentCode"  v-model="scope.row.agentName" remote filterable :filter-method="showComList" clearable placeholder="请输入" :remote-method="showComList" @change="showComList" >
                      <el-option v-for="(item) in agentList"
                                 :key="item.usercode"
                                 :label="item.customerName1"
                                 :value="item.usercode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="用户单位" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.userName'" :rules="rules.userName" class="all">
                    <el-input ref="ruserName" v-model="scope.row.userName" placeholder="请输入" clearable ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="渠道" width="110">
                <template slot-scope="scope">
                  <el-form-item   :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.customerChannel'" :rules="rules.customerChannel" class="all">
                    <brselect ref="rcustomerChannel" category="sales_region" :v="scope.row.customerChannel" v-model="scope.row.customerChannel" :clearable="true" style="width:100%" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="样本网" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.yangBenWang'" :rules="rules.yangBenWang" class="all">
                    <el-input ref="ryangBenWang" v-model="scope.row.yangBenWang" placeholder="1请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="药品网" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.yaoPinWang'" :rules="rules.yaoPinWang" class="all">
                    <el-input ref="ryaoPinWang" v-model="scope.row.yaoPinWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="液氮罐" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.yeDanGuan'" :rules="rules.yeDanGuan" class="all">
                    <el-input ref="ryeDanGuan" v-model="scope.row.yeDanGuan" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="生物安全" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.shengWuAnQuan'" :rules="rules.shengWuAnQuan" class="all">
                    <el-input ref="rshengWuAnQuan" v-model="scope.row.shengWuAnQuan" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="培养箱" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.peiYangXiang'" :rules="rules.peiYangXiang" class="all">
                    <el-input ref="rpeiYangXiang" v-model="scope.row.peiYangXiang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="离心机" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.liXinJi'" :rules="rules.liXinJi" class="all">
                    <el-input ref="rliXinJi" v-model="scope.row.liXinJi" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="试剂网" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.shiJiWang'" :rules="rules.shiJiWang" class="all">
                    <el-input ref="rshiJiWang" v-model="scope.row.shiJiWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="血液网" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.xueYeWang'" :rules="rules.xueYeWang" class="all">
                    <el-input ref="rxueYeWang" v-model="scope.row.xueYeWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="疫苗网" width="110">
                <template slot-scope="scope">
                  <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.yiMiaoWang'" :rules="rules.yiMiaoWang" class="all">
                    <el-input ref="ryiMiaoWang" v-model="scope.row.yiMiaoWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
            <!--              </el-form>-->
            <div class="flex-c-a margin-top-10">
              <el-button-group>
                <el-button type="success" icon="el-icon-info" @click="tijiao(2)">驳回</el-button>
                <el-button type="primary" icon="el-icon-check" @click="tijiao(1)">通过</el-button>
                <!--                <el-button type="success" icon="el-icon-check" @click="saveData">审批意见</el-button>-->
              </el-button-group>
              <!--                  <el-button @click="submit">暂存</el-button>-->
              <!--                  <el-button @click="submit">提交</el-button>-->
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="抢单预览" name="second">
          <el-table
              ref="multipleTableLd"
              :data="dataQd"
              border
              default-expand-all
              style="width: 100%; margin-top: 8px"
              @selection-change="handleSelectionChangeQd">
            <el-table-column
                prop="version"
                label="版本号">
            </el-table-column>
            <el-table-column
                prop="lianqun"
                label="链群">
              <template slot-scope="scope">
                <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
              </template>
            </el-table-column>
            <el-table-column
                label="渠道">
              <template slot-scope="scope">
                <dictname category="sales_region" :v="scope.row.customerChannel"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="oldGrabOrder"
                label="上次抢单金额">
            </el-table-column>
            <el-table-column
                prop="grabOrder"
                label="本次抢单金额">
            </el-table-column>
            <el-table-column
                prop="name"
                label="增长率">
            </el-table-column>
            <el-table-column
                prop="name"
                label="差因/关差计划">
            </el-table-column>
            <el-table-column
                prop="cdate"
                label="创建时间">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-form>

  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'


export default {
  data() {
    return {
      dialogFormVisible:false, // 弹窗 差因/关差原因
      TOPUp:false,
      headerStyle: {
        // 'font-weight':'500',
        // 'font-size':'20px',
        'height': '48px',
      },
      // disabled: false,
      agentList:[],// 签约经销商ls
      users:[],// 销售人员
      activeName: 'first',// tab页
      dialogLd: false,// 弹窗-选择漏斗
      dataLd: [],// 选择漏斗
      dataQd:[],// 抢单预览
      qLd: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        type: 1,
        agentName:'',// 经销商
        status:'',// 状态
        funnelCode:'',//漏斗编码
        lianqun:'',//链群
        customerChannel:'',// 渠道
        loudProductId:""// 已选中ids
      },// 选择漏斗查询条件
      baseForm: {
        demoList: [
          {
            birthday: '2010-05-02',
            name: '',
            age: '',
            address: ''
          }
        ]
      },// 非漏斗明细
      index: 0,
      rules: {
        name: [
          {
            required: true,
            message: "请输入经销商",
            trigger: "blur"
          }
        ],
        age: [
          {required: true, message: "请输入", trigger: "blur"}
        ],
        birthday: [
          {required: true, message: "请选择", trigger: "change"}
        ],
        address: [
          {required: true, message: "请输入", trigger: "blur"}
        ],
      },
      q: {
        checkStatus: "",//
        userCode: "",
        userName: "",
        approvalStatus: '',
        area: "",
        year: "2022",
        month: "",
        dates: "",
        pageNo: 1,
        pageSize: 10,
        total: 0,
        type: 1
      },
      // 列表
      dataList:[],
      bscUserMonthlyNotLoudDetails2:[],// 非漏斗明细 => 漏斗明细 数据格式
      differencePlan:'',// 关差原因
      add2:{},
      // 主表
      add: {
        year: '',// 年度
        month: '',//月度
        userCode: '',//销售人员
        userName: '',//销售人员名称
        area: '',//区域
        bscUserMonthlySummary: [],// 月度汇总
        bscUserMonthlyTargetChannel: [// 渠道目标
          {
            channel: '',//渠道
            channelCode: '',//渠道编码
            target: 0,//目标
            actual:0,// 实际
            grabOrder:0,//抢单金额
          }
        ],// 渠道目标
        bscUserMonthlyLoudDetails: [],// 明细-漏斗
        bscUserMonthlyNotLoudDetails: [{
          pid: '',//pid
          agentName: '',//经销商名称
          agentCode: '',//经销商编码
          userCode: '',//销售人员编码
          userName: '',//销售人员名称
          customerChannel: '',//渠道
          yangBenWang: 0,//样本网
          yaoPinWang: 0,//药品网
          yeDanGuan: 0,//液氮罐
          shengWuAnQuan: 0,//生物安全
          peiYangXiang: 0,//培养箱
          liXinJi: 0,//离心机
          shiJiWang: 0,//试剂网
          yiMiaoWang: 0,//疫苗网
          xueYeWang: 0,//血液网
          yunYanWang: 0,//云眼网
        }],// 非漏斗明细
      },
      checkStatusLs: [
        {"code": "0", "name": "正常"},
        {"code": "1", "name": "审批中"},
        {"code": "2", "name": "驳回"}, // 驳回的重新提交，传2
        {"code": "3", "name": "暂存"}],
      qyearList: [],
      // tableData: [],
      quyuList: [],
      qudaoList: [],
      linkList: [],// 链群
      //表格
      multipleSelection: [],
      multipleSelectionLd: [],// 漏斗选中
      multipleSelectionMx: [],// 明细选中
      multipleSelectionQd: [],
      // 展开折叠筛选
      isScreen: false,
      uploaddownexcelflag: false,
      newDialog: false,
      updatelog: false,
      detailedDialog: false,
      auditlog: false,
      switchNewTab: 1,
      productCodeList: [],
      findByNameList: [],
      showFormProductList: [],
      optionList: [],
      links: [],
      templateItems: [],
      switchBtnTab: 0,    //默认选中第一个
      title: '选项1',
      titleArr: ['选项1', '选项2'],
      planList: [],
      loudouList: [],
      rebateSeriesList: [],
      templateReachTargetList: [],
      monthList: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      editFormRules: {
        username: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        link: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        chanel: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        product: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        custMonth: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        grabBill: [{required: true, message: '请输入必填项', trigger: 'blur'}],
      },
      qyFlag: false,
    }
  },
  methods: {
    chayin(){
      this.$message({
        showClose: true,
        message: '我是差因',
        type: 'success'
      });
    },
    // 合计数组某个字段
    sumFieldByData(data,field){
      return data.reduce(function (total, currentValue, currentIndex, arr){
        return currentValue[field] ? (parseFloat(total)  + parseFloat(currentValue[field])) : total;
      }, 0);
    },
    // 批量删除明细
    deleteSeleteMx(){
      // 删除漏斗明细选中行
      this.multipleSelectionMx.forEach(element => {
        this.$refs.multipleTableLd.toggleRowSelection(element);// 并删除选中（因为这里有分页选择）
        this.add.bscUserMonthlyLoudDetails.splice(this.add.bscUserMonthlyLoudDetails.indexOf(element), 1);
      });
      // 漏斗明细合并到月度汇总
      let bscUserMonthlySummary_ = this.arrayGroup(this.add.bscUserMonthlyLoudDetails.concat(this.bscUserMonthlyNotLoudDetails2));
      this.add.bscUserMonthlySummary=bscUserMonthlySummary_;
      this.$set(this.add, this.add.bscUserMonthlySummary,bscUserMonthlySummary_);
      this.updateMain();// 更新主体
      // this.$message({
      //   showClose: true,
      //   message: '月度汇总，漏斗明细已更新',
      //   type: 'success'
      // });
    },
    // 更新主体 （包含 ：月度汇总合计）
    updateMain(){
      let this_ = this;
      let idx = 0;
      let bscUserMonthlyTargetChannel_ = this.add.bscUserMonthlyTargetChannel.map(function (curr) {
        return {
          idx:idx++,
          grabOrder :
              this_.add.bscUserMonthlySummary.filter(t=> t.customerChannel==curr.channelCode).reduce(function (total, currentValue, currentIndex, arr){
                return currentValue['customerChannel'] ? (total + currentValue['grabOrder']) : total;
              }, 0).toFixed(2),
          channel: curr.channel,//渠道
          channelCode: curr.channelCode,//渠道编码
          target: curr.target,//目标
          actual:curr.actual,// 实际
        }
      });
      this.add.bscUserMonthlyTargetChannel = bscUserMonthlyTargetChannel_;
      // 月度汇总合计
      this.add.contractTargetSum = this.sumFieldByData(this.add.bscUserMonthlySummary,'contractTarget');// 签约目标
      this.add.loudSum = this.sumFieldByData(this.add.bscUserMonthlySummary,'loudSum');// 漏斗金额（万元）
      this.add.notLoudSum = this.sumFieldByData(this.add.bscUserMonthlySummary,'notLoudSum');// 非漏斗金额（万元）
      this.add.grabOrderSum = this.sumFieldByData(this.add.bscUserMonthlySummary,'grabOrder');// 抢单金额（万元）
    },
    //签约经销商
    showComList(value) {
      ss.netApi.selectByUserNameLoud(value).then(res => {
        // console.log(res)
        this.agentList = res.obj.slice(0,100);
        // this.loudmain.agentCode = res.obj[0].usercode
      })
    },
    // 漏斗弹窗
    showLd(){
      this.dialogLd = true;
      this.restLd();
      this.getLoudList();// 获取漏斗信息


    },
    // 获取漏斗信息
    getLoudList(){
      this.qLd.month= this.add.month;
      this.qLd.monthUser= this.add.userCode;
      this.qLd.loudProductId='';
      if(this.add.bscUserMonthlyLoudDetails!=null)
        this.qLd.loudProductId= this.add.bscUserMonthlyLoudDetails.map(item=>{return item.loudProductId}).join(",");
      let ts = this;
      ss.netApi.getLoudList(this.qLd).then(res => {
        this.dataLd = res.records;
        this.qLd.total= res.total || 0;
        // this.formInline.total = rd.total || 0;
      })
    },
    // 获取 渠道目标
    // getTargetChannel(row){//
    //   let query= {"targetDate": this.add.month, "userCode": this.add.userCode, "area": this.add.area};
    //   ss.netApi.getTargetChannel(query).then(res => {
    //     let _arr = []
    //     let idx = 0;
    //     res.obj.map((item, index) => {
    //       _arr.push(Object.assign({},item,{idx: idx}));
    //       idx++;
    //     });
    //     // _arr.push(_arr[1]);
    //     // _arr.push(_arr[1]);
    //     // _arr = _arr.slice(0,1)
    //     // console.log(1001,_arr);
    //     // console.log(123,_arr);
    //     this.add.bscUserMonthlyTargetChannel=_arr;
    //     this.$set(this.add, this.add.bscUserMonthlyTargetChannel,_arr);
    //   })
    // },
    // 获取 销售人员
    getUserList(){//
      ss.netApi.getUserList().then(res => {
        this.users=res.obj;
      })
    },
    // 选择漏斗分页
    // selectPageAllLd() {//
    //   ss.netApi.selectPageCustom(this.qLd).then(res => {
    //     console.log(res.records)
    //     this.dataLd = res.records
    //     this.qLd.total = res.total
    //   })
    // },
    // 月度抢单 列表
    selectPageAll() {//selectPageCustom
      ss.netApi.selectMonthlyList(this.q).then(res => {
        // console.log(res.obj)
        this.dataList = res.records;
        this.q.total = res.total
      })
    },
    // 非漏斗明细
    // 选中某一行修改或移除
    selectItem(row, column, event) {
      this.selectedFundRow = row
      if (event.target.innerText == "－") {
        // if(event.target.innerHTML.indexOf('el-icon-minus')!=-1){
        this.removeFundBtn(this.selectedFundRow)
      }
    },
    // 删除指定行
    removeFundBtn(params) {
      this.add.bscUserMonthlyNotLoudDetails = this.add.bscUserMonthlyNotLoudDetails.filter((ele) => {
        var flag = false
        // 如果不一致，则保留该行
        for (const key in params) {
          if (ele[key] != params[key]) {
            flag = true
            break
          }
        }
        return flag
      })
      // 如果全部删除后没有可以点击的一行了，需要加一行空行
      if (!this.add.bscUserMonthlyNotLoudDetails.length) {
        this.addLine()
      }
    },
    // 非漏斗明细更新到月度汇总
    updateDataYd(){
      let lines = this.add.bscUserMonthlyNotLoudDetails;// 非漏斗明细
      let this_ = this;
      if (lines.length==1 && lines[0].yangBenWang==0 && lines[0].yaoPinWang==0 && lines[0].yeDanGuan==0 && lines[0].shengWuAnQuan==0 && lines[0].peiYangXiang==0 && lines[0].liXinJi==0 && lines[0].shiJiWang==0 && lines[0].xueYeWang==0 && lines[0].yiMiaoWang==0 &&  lines[0].agentCode==0 && lines[0].userName==0 && lines[0].customerChannel==0) { // 数据都被删
        this_.add.bscUserMonthlySummary = this_.arrayGroup(this_.add.bscUserMonthlyLoudDetails);// 更新月度汇总
        this_.bscUserMonthlyNotLoudDetails2=[];
        this_.updateMain();// 更新主体
      } else if(this.yz(lines)) {// 验证
        let querys= [];// 查询集合 (也是要汇总的条数)
        lines.forEach(item => {
          let lianquns = [];// 9个链群集合
          lianquns.push({code : 'X02', name : '样本网', val : parseFloat(item.yangBenWang)});// 样本网
          lianquns.push({code : 'X01', name : '药品网', val : parseFloat(item.yaoPinWang)});// 药品网
          lianquns.push({code : 'X04', name : '液氮罐', val : parseFloat(item.yeDanGuan)});// 液氮罐
          lianquns.push({code : 'X08', name : '生物安全', val : parseFloat(item.shengWuAnQuan)});// 生物安全
          lianquns.push({code : 'X09', name : '培养箱', val : parseFloat(item.peiYangXiang)});// 培养箱
          lianquns.push({code : 'X10', name : '离心机', val : parseFloat(item.liXinJi)});// 离心机
          lianquns.push({code : 'X07', name : '试剂网', val : parseFloat(item.shiJiWang)});// 试剂网
          lianquns.push({code : 'X05', name : '血液网', val : parseFloat(item.xueYeWang)});// 血液网
          lianquns.push({code : 'X06', name : '疫苗网', val : parseFloat(item.yiMiaoWang)});// 疫苗网
          lianquns.map(itemLq => {
            let totalPriceF_ = 0;// 非漏斗金额
            if(itemLq.val != 0) {
              querys.push({
                month: this_.add.month,
                agentCode: item.agentName,// 经销商编码
                agentName: '',// 经销商名称 后台取
                contractTarget:0,// 签约目标 后台取
                userUnit:item.userName,// 用户单位
                lianqun: itemLq.code,// 链群编码
                lianqunName: itemLq.name,// 链群名称
                channel:item.customerChannel,// 渠道编码
                notLoudSum:itemLq.val,// 非漏斗金额
              });
            }
          });
        });
        // 后台 => 换取签约目标
        // ss.netApi.getNotLoudTarget(querys).then(res => {
        //   // 签约目标数据 => 漏斗明细 数据格式
        //   this_.bscUserMonthlyNotLoudDetails2 = res.obj.map(item => {
        //     return {
        //       pid: '',
        //       agentName: item.agentName,// 经销商名称
        //       agentCode: item.agentCode,// 经销商编码
        //       expConvDate: item.month+'-'+new Date().getDate(),// 月度
        //       week: '',// 周
        //       lianqun: item.lianqun,// 链群
        //       customerChannel: item.channel,// 渠道
        //       contractTarget: item.contractTarget,// 签约目标
        //       totalPrice: 0,// 漏斗金额（万元）
        //       totalPriceF: parseFloat(item.notLoudSum) ,// 非漏斗金额（万元）
        //       // totalPrice: item.totalPrice,//抢单金额（万元）
        //     }
        //   });
        //   // 转换字段名称: 用漏斗明细 数据格式 => arrayGroup(转换月度汇总格式)
        //   let bscUserMonthlyLoudDetails_ = this_.add.bscUserMonthlyLoudDetails==null?[]:this_.add.bscUserMonthlyLoudDetails;
        //   let bscUserMonthlySummary_ = this_.arrayGroup(bscUserMonthlyLoudDetails_.concat(this_.bscUserMonthlyNotLoudDetails2));
        //   this_.add.bscUserMonthlySummary=bscUserMonthlySummary_;
        //   this_.$set(this_.add, this_.add.bscUserMonthlySummary,bscUserMonthlySummary_);
        //   this_.updateMain();// 更新主体
        //   console.log(1);
        //   // this_.$message({
        //   //   showClose: true,
        //   //   message: '月度汇总，非漏斗明细已更新',
        //   //   type: 'success'
        //   // });
        // });
      }
    },
    // 增加一个空行, 用于录入或显示第一行
    addLine() {
      const newLine = {
        pid: '',//pid
        agentName: '',//经销商名称
        agentCode: '',//经销商编码
        userCode: '',//销售人员编码
        userName: '',//销售人员名称
        customerChannel: '',//渠道
        yangBenWang: 0,//样本网
        yaoPinWang: 0,//药品网
        yeDanGuan: 0,//液氮罐
        shengWuAnQuan: 0,//生物安全
        peiYangXiang: 0,//培养箱
        liXinJi: 0,//离心机
        shiJiWang: 0,//试剂网
        yiMiaoWang: 0,//疫苗网
        xueYeWang: 0,//血液网
        yunYanWang: 0,//云眼网
      };
      // this.index++;
      let lines = this.add.bscUserMonthlyNotLoudDetails;
      if(this.yz(lines)) {// 验证
        lines.push(newLine);
      }
    },
    // 验证 bscUserMonthlyNotLoudDetails
    yz(datas){
      let f = true;
      let this_ = this;
      let mes = '';
      datas.slice(0,datas.length).map(function (data) {
        if(data.agentName == ''){
          mes = '请输入经销商';
          f = false
        } else if(data.customerChannel == ''){
          mes = '请输入渠道';
          f = false
        } else if(data.yangBenWang === ''){
          mes = '请输入样本网';
          f = false
        } else if(data.yaoPinWang === ''){
          mes = '请输入药品网';
          f = false
        } else if(data.yeDanGuan === ''){
          mes = '请输入液氮罐';
          f = false
        } else if(data.shengWuAnQuan === ''){
          mes = '请输入生物安全';
          f = false
        } else if(data.peiYangXiang === ''){
          mes = '请输入培养箱';
          f = false
        } else if(data.liXinJi === ''){
          mes = '请输入离心机';
          f = false
        } else if(data.shiJiWang === ''){
          mes = '请输入试剂网';
          f = false
        } else if(data.xueYeWang === ''){
          mes = '请输入血液网';
          f = false
        } else if(data.yiMiaoWang === ''){
          mes = '请输入疫苗网';
          // this_.$refs.ryiMiaoWang.focus();
          f = false
        }
      });
      if(mes!='')
        this_.$message({
          message: mes,
          type: 'warning'
        });
      return f;
    },
    // 编辑
    updateDetail(row){
      let rowNew = new Array();
      this.add2 = JSON.parse(JSON.stringify(row));//深度拷贝
      this.cleanAdd(this.add2,'update');
      this.add2.month=this.add2.year+'-'+this.add2.month;// 拼接月度
      // 获取抢单预览
      let this_ = this;
      let qdprms = { id: this_.add2.id, version: this_.add2.version};
      ss.netApi.monthlyListByHistory(qdprms).then(res => {
        if(res.f) {
          this_.dataQd = res.obj;
        }
      });
      // this.getTargetChannel(row);// 获取渠道目标
      // this.add=row;
      // this.updateMain();// 更新主体 ,处理渠道目标，合计抢单金额
      // this.add.bscUserMonthlyTargetChannel
      // this.$set(this.add, this.add.bscUserMonthlyTargetChannel,this.add.bscUserMonthlyTargetChannel);
      // console.log(row);
    },
    // 删除
    deleteSingle(id){
      let data ={
        ids:id
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.netApi.deleteMonthly(data).then(res => {
          console.log(res)
          if(res.f == true ){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.selectPageAll()
          }else{
            this.$message.error(res.msg);
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    tijiao(exeNum){
      let urls = this.$route.query;
      this.add.aaa=exeNum;
      this.add.taskid=urls.taskid;
      this.add.instid=urls.instid;
      this.add.auditMind=exeNum==1?"已通过":"驳回";
      ss.netApi.monthlyPass(this.add).then(response => {
        if (response.f) {
          this.$msg.alerts("提交成功！", () => {
            //刷新右上角的代办个数
            this.$store.dispatch("searchTasktotal")
            //跳转回系统的代办列表
            this.$router.push({path: '/personal/dealCenter'})
          })
        }
      });
    },
    // 暂存、提交、编辑
    saveData(){
      let this_ = this;
      if(this.add2.id!=null){// 编辑
        ss.netApi.updateMonthly(this.add2).then(res => {
          console.log(1008,res);
          if(res.f) {
            this_.selectPageAll();
            this_.newDialog = false;
          }
        });
      } else {
        // 提交
        ss.netApi.insertMonthly(this.add).then(res => {
          console.log(res);
          if (res.f) {
            this_.selectPageAll();
            this_.newDialog = false;
          }
        });
      }
    },
    // 提交
    // submit() {
    //   this.$refs.add.validate((valid) => {
    //     if (valid) {
    //       this.$confirm("您确定【提交】？", "提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning"
    //       }).then(() => {
    //         console.log("校验通过")
    //       })
    //     }
    //   })
    // },
    // 明细删除行
    deleteRowMx(index, rows) {
      this.$refs.multipleTableLd.toggleRowSelection(rows[index]);// 并删除选中（因为这里有分页选择）
      // this.$refs.multipleTableLd.clearSelection();
      rows.splice(index, 1);
      // 漏斗明细合并到月度汇总
      let bscUserMonthlySummary_ = this.arrayGroup(this.add.bscUserMonthlyLoudDetails.concat(this.bscUserMonthlyNotLoudDetails2));
      this.add.bscUserMonthlySummary=bscUserMonthlySummary_;
      this.$set(this.add, this.add.bscUserMonthlySummary,bscUserMonthlySummary_);

      this.updateMain();// 更新主体
      // this.$message({
      //   showClose: true,
      //   message: '月度汇总，漏斗明细已更新',
      //   type: 'success'
      // });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTableLd.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTableLd.clearSelection();
      }
    },
    // 添加到明细 漏斗
    addMx(){
      this.add.bscUserMonthlyLoudDetails = this.add.bscUserMonthlyLoudDetails.concat(this.multipleSelectionLd);// 选中的添加到明细
      // this.add.bscUserMonthlyLoudDetails = this.multipleSelectionLd;// 选中的添加到明细
      this.dialogLd = false;// 选择漏斗 关闭
      // 漏斗明细合并到月度汇总
      let bscUserMonthlySummary_ = this.arrayGroup(this.add.bscUserMonthlyLoudDetails.concat(this.bscUserMonthlyNotLoudDetails2));
      this.add.bscUserMonthlySummary=bscUserMonthlySummary_;
      this.$set(this.add, this.add.bscUserMonthlySummary,bscUserMonthlySummary_);
      this.updateMain();// 更新主体

      this.$refs.multipleTableLd.clearSelection();
      // this.$message({
      //   showClose: true,
      //   message: '月度汇总，漏斗明细已更新',
      //   type: 'success'
      // });
    },
    // 并转换字段名称;数组分组统计; 漏斗
    arrayGroup(inData){
      let fthis = this;
      // 转换字段名称
      let newnewArr =  inData.map(item => {
        let totalPriceF_ = item.totalPriceF == null ? 0 : item.totalPriceF;
        let contractTarget_ =item.contractTarget == null ? 0 : item.contractTarget;
        let totalPrice_ =item.totalPrice == null ? 0 : item.totalPrice;
        return {
          pid: '',
          agentName: item.agentName,//经销商名称
          agentCode: '',//经销商编码
          month: item.expConvDate.substring(0,item.expConvDate.lastIndexOf('-')),//月度
          week: '',//周
          lianqun: item.lianqun,//链群
          customerChannel: item.customerChannel,//渠道
          contractTarget: contractTarget_,//fthis.add.bscUserMonthlyTargetChannel.find(t => t.channelCode==item.customerChannel).target,//签约目标
          loudSum: totalPrice_,//漏斗金额（万元）
          notLoudSum: totalPriceF_,//非漏斗金额（万元）
          grabOrder: totalPrice_+totalPriceF_,//抢单金额（万元）
        }
      });
      // 分组统计
      let ydGroup = newnewArr.reduce((total, cur, index) => {
        let hasValue = total.findIndex(current => {
          // current.code === cur.code && current.t === cur.t
          return current.agentName === cur.agentName &&
              current.month === cur.month &&
              current.lianqun === cur.lianqun &&
              current.customerChannel === cur.customerChannel
        })
        hasValue === -1 && total.push(cur)
        hasValue !== -1 && (total[hasValue].loudSum = total[hasValue].loudSum + cur.loudSum)
        hasValue !== -1 && (total[hasValue].notLoudSum = total[hasValue].notLoudSum + cur.notLoudSum)
        hasValue !== -1 && (total[hasValue].grabOrder = total[hasValue].loudSum + total[hasValue].notLoudSum)
        return total
      }, []);
      return ydGroup;
    },
    // 合计列
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        } else if (index <= 3) {
          sums[index] = '-';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // console.log(10011,sums[index]);
          //
          sums[index] = sums[index]!=0?sums[index].toFixed(2):sums[index];// 保留2位小数
          sums[index] += '';//' 万元'
          sums[index] = parseFloat(sums[index]).toFixed(2);
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    // 新增月度抢单 弹窗
    createNew() {
      this.cleanAdd(this.add,'add');
      // this.getTargetChannel();// 获取渠道目标
    },
    // closeNew(){
    //   this.TOPUp = false; // 返回顶部
    // },
    // 初始化弹窗，清除数据
    cleanAdd(row,exeType){
      this.TOPUp = true; // 返回顶部
      this.newDialog = true;
      this.add= {
        year: '',// 年度
        month: '',//月度
        userCode: '',//销售人员
        userName: '',//销售人员名称
        area: '',//区域
        bscUserMonthlySummary: [],// 月度汇总
        bscUserMonthlyTargetChannel: [// 渠道目标
          {
            channel: '',//渠道
            channelCode: '',//渠道编码
            target: 0,//目标
            actual:0,// 实际
            grabOrder:0,//抢单金额
          }
        ],// 渠道目标
        bscUserMonthlyLoudDetails: [],// 明细-漏斗
        bscUserMonthlyNotLoudDetails: [{
          pid: '',//pid
          agentName: '',//经销商名称
          agentCode: '',//经销商编码
          userCode: '',//销售人员编码
          userName: '',//销售人员名称
          customerChannel: '',//渠道
          yangBenWang: 0,//样本网
          yaoPinWang: 0,//药品网
          yeDanGuan: 0,//液氮罐
          shengWuAnQuan: 0,//生物安全
          peiYangXiang: 0,//培养箱
          liXinJi: 0,//离心机
          shiJiWang: 0,//试剂网
          yiMiaoWang: 0,//疫苗网
          xueYeWang: 0,//血液网
          yunYanWang: 0,//云眼网
        }],// 非漏斗明细
      },
          // this.$refs.multipleTableLd.toggleRowSelection();// 并删除选中（因为这里有分页选择）
          this.add.month = new Date().getFullYear()+"-"+(new Date().getMonth()+1<10?"0"+(new Date().getMonth()+1):(new Date().getMonth()+1));// 年月
      this.add.userName=this.$store.getters.user.username;// 销售人员
      this.add.userCode=localStorage.getItem("userId");// 销售人员
      try {
        let userid = localStorage.getItem("userId");
        userid = userid.trim();
        let areacd = this.users.find(t=> t.userCode==userid).areaCode;// 区域
        this.add.area = areacd;
      }catch (e){
        // this.add.area="BEI_JING";// 没取到区域默认一个
      }
      let this_ = this;

      // 用编辑行数据传参查询渠道目标
      if(exeType == 'update'){
        this.add.month=row.year+"-"+row.month;
        this.add.userCode=row.userCode;
        this.add.area=row.area;
      }
      let query= {"targetDate": this.add.month, "userCode": this.add.userCode, "area": this.add.area};
      // 获取渠道目标
      ss.netApi.getTargetChannel(query).then(res => {
        let _arr = []
        let idx = 0;
        res.obj.map((item, index) => {
          _arr.push(Object.assign({},item,{idx: idx}));
          idx++;
        });
        this_.add.bscUserMonthlyTargetChannel=_arr;
        this_.$set(this_.add, this_.add.bscUserMonthlyTargetChannel,_arr);
        // this.updateMain();// 更新主体
        if(exeType=='update'){
          // row.bscUserMonthlyTargetChannel=this_.add.bscUserMonthlyTargetChannel;
          this_.add = row;
          this_.add.month=this_.add.year+'-'+this_.add.month;//
          this_.updateDataYd();// 非漏斗明细 to 月度汇总
          this_.updateMain();// 更新主体

          this_.add.bscUserMonthlySummary.forEach((node) => {
            node.month = node.month.length==2?this_.add.year+'-'+node.month:node.month
          });
        }
      });
    },
    //关闭弹框的事件
    closeDialog() {
      this.TOPUp = false; // 返回顶部
      this.newDialog = false;
      this.add2=[];
      this.bscUserMonthlyNotLoudDetails2=[];
      this.add ={
        year: '',// 年度
        month: '',//月度
        userCode: '',//销售人员
        userName: '',//销售人员名称
        area: '',//区域
        bscUserMonthlySummary: [],// 月度汇总
        bscUserMonthlyTargetChannel: [// 渠道目标
          {
            channel: '',//渠道
            channelCode: '',//渠道编码
            target: 0,//目标
            actual:0,// 实际
            grabOrder:0,//抢单金额
          }
        ],// 渠道目标
        bscUserMonthlyLoudDetails: [],// 明细-漏斗
        bscUserMonthlyNotLoudDetails: [{
          pid: '',//pid
          agentName: '',//经销商名称
          agentCode: '',//经销商编码
          userCode: '',//销售人员编码
          userName: '',//销售人员名称
          customerChannel: '',//渠道
          yangBenWang: 0,//样本网
          yaoPinWang: 0,//药品网
          yeDanGuan: 0,//液氮罐
          shengWuAnQuan: 0,//生物安全
          peiYangXiang: 0,//培养箱
          liXinJi: 0,//离心机
          shiJiWang: 0,//试剂网
          yiMiaoWang: 0,//疫苗网
          xueYeWang: 0,//血液网
          yunYanWang: 0,//云眼网
        }],// 非漏斗明细
      }
    },
    restLd(){
      this.qLd= {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        type: 1,
        agentName:'',// 经销商
        status:'',// 状态
        funnelCode:'',//漏斗编码
        lianqun:'',//链群
        customerChannel:'',// 渠道
        loudProductId:""// 已选中ids
      }
    },
    // 列表筛选条件 重置
    rest(){
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q= {
        area:"",
        usercode:"",
        username:"",
        year: "",
        pageSize: pageSize,
        pageNo: pageNo,
        total:total,
        type:1
      }
    },
    // 批量删除
    deleteSelete(){
      var data = this.multipleSelection.map(item => item.id).join()
      console.log(data)
      this.deleteSingle(data)
    },

    getValue(){
      let newUser = this.users.find(t=> t.userCode==this.add.userName);// 获取选中 销售人员
      this.add.userCode = newUser.userCode;
      this.add.userName = newUser.userName;
      this.add.area = newUser.areaCode;// 更新区域
    },
    //
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    //导出
    exportExcel() {
      ///api/swyl/v1/monthly/order/common/downloadExcel
      updownfile.down("/api/swyl/v1/monthly/order/common/downloadExcel", this.q, "post", 'data');
    },
    exit(){
      this.newDialog= false,
          this.editDialog = false
    },
    close(){
      this.detailedDialog= false
    },
    exitColse(){
      console.log("sfdsd")
      this.detailedDialog = false
    },

    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChangeLd(val) {
      this.multipleSelectionLd = val;
    },
    handleSelectionChangeMx(val) {
      this.multipleSelectionMx = val;
    },
    handleSelectionChangeQd(val) {
      this.multipleSelectionQd = val;
    },
    getQuyuList() {
      ss.Dictservice.listbycategory("show_area").then(rd => {
        this.quyuList = rd;
      })
    },
    getQudaoList() {
      ss.Dictservice.listbycategory("sales_region").then(rd => {
        this.qudaoList = rd;
      })
    },
    getLinkList() {
      ss.Dictservice.listbycategory("xsyb_lianqun").then(rd => {
        this.linkList = rd;
      })
    },
  },
  created() {
    this.getUserList();// 获取销售人员
    //this.getNowTime()
    this.selectPageAll();// 月度抢单列表
    // this.selectPageAllLd();// 选择漏斗
    // this.showplanList()
    // //this.shouLoudou()
    // this.showRebateSeries()
    // this.showTemplateReachTarget()
    this.getQuyuList();
    this.getQudaoList();
    this.getLinkList();
    for (var i = 2021; i < new Date().getFullYear() + 2; i++) {
      this.qyearList.push(i);
    }
    if (this.$store.getters.hasRole('crm_quyu')) {
      this.qyFlag = true;
    }
    let this_ = this;
    this.$route.query;
    // 获取渠道目标
    ss.netApi.selectByInstid(this.$route.query).then(res => {
      this_.cleanAdd(res,'update');
      // this_.add.month = this_.add.year+'-'+this_.add.month;
      // 获取抢单预览
      let qdprms = { id: res.id, version: res.version};
      ss.netApi.monthlyListByHistory(qdprms).then(res => {
        if(res.f) {
          this_.dataQd = res.obj;
        }
      });
    });
  },
  components: {
    uploaddownexcel,
  },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
  width: 105px;
}

/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}

.addPro {
  width: 100%;
  /* display:flex; */
}

.addPro .el-form-item {
  width: 31% !important;
}

.addPro .el-form-item /deep/ .el-form-item__content {
  width: 280px;
}

.addPro .el-dialog__body {
  padding: 0 0;
}

.addPro .el-form-item /deep/ .el-input__inner {
  height: 37px;
  line-height: 37px;
}

/* 切换 */
.card-namber {
  border-bottom: #dbdbdb 2px solid;
}

.card-namber span {
  padding: 0 10px;
}

.buttonActive {
  color: #1b78e6;
  border-bottom: #1b78e6 2px solid;
  font-size: 14px;
  font-weight: 600
}



.projectCon {
  display: flex;
  padding: 5px 0;
  margin: 0 10px 5px 10px;
  color: #1b78e6;
}

.projectCon p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  border-bottom: #1b78e6 1px dashed;
  padding: 5px 0;
  margin: 0 auto 10px auto;
  color: #1b78e6;
}

</style>

<style lang='less' scoped>
.clolos1 { //增加按钮样式
  width: 13px;
  height: 30px;
  background: #29affb;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 15px;
  color: #fff;
  position: absolute;
  margin-left: 65.35%;
  margin-top: 8.48%;
  z-index: 1;
}

.clolos2 {
  width: 13px;
  height: 30px;
  background: #29affb;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 15px;
  color: #fff;
  position: absolute;
  margin-left: 65%;
  margin-top: 7%;
}

.clolos3 { //删除按钮样式
  width: 13px;
  height: 30px;
  background: red;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 15px;
  color: #fff;
  position: absolute;
  margin-left: calc(100% + 40px);
  margin-top: 10%;
}

.add_pdf {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  width: 80%;
  position: relative;
  margin-top: 3%;
}

.basicinformation {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  width: 80%;
  position: relative;
}

.h-bgblueQ1 {
  background: #c61c1c;
}

.p {
  border-left: 6px solid #00C2FF;
  background-color: #E8F8FF;
  margin-top: 15px;
  margin-bottom: 10px;
  height: 38px;
  line-height: 38px;
  padding-left: 10px;
  font-size: 15px;
  //font-weight:800;
}

.tag-group span {
  border-radius: 5px;
  margin: -8px 5px 15px 5px;
}

// 非漏斗明细
.all {
  //width: 100%;
  height: 20px
}

.flex-c-a {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.margin-top-10 {
  margin-top: 10px;
}

.base-form.el-form-item__content {
  margin-left: 10px;
}

.add-btn {
  color: #4077F4;
}

.delete-btn {
  color: #f56c6c;
}

#fldcz {
  height: 99px;
}
/deep/.el-table .el-table__footer-wrapper .cell{
  text-align: right;
}
#TOPUp{
  position: fixed;
  right: 20px;
  bottom: 5px;
  width: 40px;
  height: 40px;
  z-index: 99999999;
  //box-shadow: 0px 0px 4px 4px #ecefef;
  //border-radius: 600px;
}
</style>
